import { themeColor, Color, BaseColor, Typography, rem, spacing, ColorShade } from '~theme'
import styled from 'styled-components'
import { DatePickerSize } from './DatePicker.types'
import { ThemeColorGetter } from '../../theme/palette'

interface ContainerProps {
  size: DatePickerSize
  colors?: {
    selected?: ThemeColorGetter
    hover?: ThemeColorGetter
    dot?: ThemeColorGetter
    dotOnSelected?: ThemeColorGetter
  }
}

export const Container = styled.div<ContainerProps>`
  & .rdp {
    margin: 0;

    /* See file react-day-picker/dist/style.css for selectors and variables */
    --rdp-cell-size: ${({ size }) => {
      switch (size) {
        case 'medium':
          return '3.5rem'
        case 'small':
          return '2rem'
        case 'large':
          return '5rem'
        default:
          return size
      }
    }};
    --rdp-accent-color: ${props => props.colors?.selected || themeColor(Color.primary)};
    --rdp-background-color: ${props => props.colors?.hover || themeColor(BaseColor.shade_20)};
    /* We handle dark themes by ouselves, so these are redundant. */
    /* But they need to be set so the default values aren't used. */
    --rdp-accent-color-dark: var(--rdp-accent-color);
    --rdp-background-color-dark: var(--rdp-background-color);
    --booked-day-color: ${props => props.colors?.dot || themeColor(Color.primary)};
    --booked-day-alternate-color: ${props => props.colors?.dotOnSelected || themeColor(Color.primary, ColorShade.stronger)};

    & .booked {
      &::before {
        z-index: 1;
        content: '.';
        font-size: ${rem(32)};
        position: absolute;
        bottom: ${({ size }) => {
          switch (size) {
            case 'small':
              return spacing(0.15)
            case 'large':
              return spacing(1)
            case 'medium':
            default:
              return spacing(0.5)
          }
        }};
        color: var(--booked-day-color);
      }

      &.rdp-day_selected {
        &::before {
          color: var(--booked-day-alternate-color);
        }
      }
    }

    & .rdp-head_row {
      border-bottom: 1px solid ${themeColor(BaseColor.shade_40)};
    }

    & .rdp-head_cell {
      text-transform: none;
      ${Typography.labelLarge};
      ${Typography.textRegular};
    }

    /* Anything above the button is a table child element and doesn't accept margins */
    & .rdp-tbody > .rdp-row:first-child > .rdp-cell > button {
      margin-top: ${rem(5)};
    }
  }
`

export const DayContainer = styled.div`
  z-index: 2;
`
